import * as React from 'react'

import { Radio } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { employeeUser } from 'modules/core/store/collections/users'

import { getCopies } from 'modules/contracts/components/FlowSelectorModal/utils'
import type Employee from 'modules/employees/store/models/Employee'
import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'

import FixRadioOption from '../RadioOptions/FixRadioOption'
import PromoteRadioOption from '../RadioOptions/PromoteRadioOption'
import UpdateRadioOption from '../RadioOptions/UpdateRadioOption'

interface Props {
  showFixOption: boolean
  employee: Employee
  value: string
  onChange: (option: React.SetStateAction<string>) => void
}

const OngoingModalContent = ({ showFixOption, employee, value, onChange }: Props) => {
  const copies = getCopies(employeeUser(employee).fullName())
  const canPromote = policyAuthorizations.for('contracts.promote', employee)
  const canEdit = policyAuthorizations.for('contracts.edit', employee)

  return (
    <>
      {canPromote && (
        <Radio.Wrap>
          <PromoteRadioOption title={copies.promote} value={value} onChange={onChange} />
        </Radio.Wrap>
      )}
      {canEdit && (
        <Radio.Wrap>
          <UpdateRadioOption title={copies.update} value={value} onChange={onChange} />
        </Radio.Wrap>
      )}
      {canEdit && showFixOption && (
        <Radio.Wrap>
          <FixRadioOption title={copies.fix} value={value} onChange={onChange} />
        </Radio.Wrap>
      )}
    </>
  )
}

export default observer(OngoingModalContent)
